import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import "../../styles/mudur/VardiyaPlanlama.css";
import "../../styles/mudur/Puantaj.css";
import SayfaYardimPopup from "./SayfaYardimPopup";
const gunAdlari = [
    "Pazartesi",
    "Salı",
    "Çarşamba",
    "Perşembe",
    "Cuma",
    "Cumartesi",
    "Pazar",
];

const fazlaMesaiDurumlari = [
    { value: "Secilmedi", label: "Seçilmedi" },
    { value: "Beklemede", label: "Beklemede" },
    { value: "Onaylandi", label: "Onaylandı" },
    { value: "Reddedildi", label: "Reddedildi" },
];

const getMonday = (date) => {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1);

    d.setDate(diff);
    d.setHours(0, 0, 0, 0);

    return d;
};

const addDays = (date, count) => {
    const d = new Date(date);
    d.setDate(d.getDate() + count);
    return d;
};


const getMonthStart = (date) => {
    const d = new Date(date);
    d.setDate(1);
    d.setHours(0, 0, 0, 0);
    return d;
};

const getMonthEnd = (date) => {
    const d = new Date(date);
    d.setMonth(d.getMonth() + 1);
    d.setDate(0);
    d.setHours(0, 0, 0, 0);
    return d;
};

const addMonths = (date, count) => {
    const d = new Date(date);
    d.setMonth(d.getMonth() + count);
    return d;
};

const formatMonthName = (date) => {
    return new Date(date).toLocaleDateString("tr-TR", {
        month: "long",
        year: "numeric",
    });
};

const inputDateFormat = (date) => {
    const d = new Date(date);
    const yil = d.getFullYear();
    const ay = String(d.getMonth() + 1).padStart(2, "0");
    const gun = String(d.getDate()).padStart(2, "0");

    return `${yil}-${ay}-${gun}`;
};

const formatDateForApi = (date) => {
    const d = new Date(date);
    const yil = d.getFullYear();
    const ay = String(d.getMonth() + 1).padStart(2, "0");
    const gun = String(d.getDate()).padStart(2, "0");

    return `${yil}-${ay}-${gun}`;
};

const formatDate = (date) => {
    return new Date(date).toLocaleDateString("tr-TR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
};

const getIsoWeekNumber = (date) => {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;

    d.setUTCDate(d.getUTCDate() + 4 - dayNum);

    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);

    return weekNo;
};

const getHaftaBilgisi = (date) => {
    return `${getIsoWeekNumber(date)}. Hafta`;
};

const apiArrayGetir = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.data?.$values)) return payload.data.$values;
    if (Array.isArray(payload?.$values)) return payload.$values;
    if (Array.isArray(payload?.items)) return payload.items;
    if (Array.isArray(payload?.data?.items)) return payload.data.items;

    return [];
};

const lokasyonAdinaGoreSirala = (liste = []) => {
    return [...liste].sort((a, b) =>
        String(a.ad || "").localeCompare(String(b.ad || ""), "tr")
    );
};

const lokasyonOrgIdGetir = (lokasyon = {}) => {
    return lokasyon.organizasyonBirimiId || lokasyon.id;
};

const lokasyonunAltBirimiVarMi = (lokasyon, tumLokasyonlar = []) => {
    const orgId = lokasyonOrgIdGetir(lokasyon);

    return tumLokasyonlar.some(
        (item) => String(item.ustBirimId) === String(orgId)
    );
};

const lokasyonSelectListesiOlustur = (liste = []) => {
    const tumListe = apiArrayGetir(liste).filter(Boolean);
    const eklenenler = new Set();
    const sonuc = [];

    const ustLokasyonlar = lokasyonAdinaGoreSirala(
        tumListe.filter((lokasyon) =>
            lokasyonunAltBirimiVarMi(lokasyon, tumListe)
        )
    );

    ustLokasyonlar.forEach((ustLokasyon) => {
        const ustOrgId = lokasyonOrgIdGetir(ustLokasyon);

        sonuc.push({
            ...ustLokasyon,
            gorunenAd: `▸ ${String(ustLokasyon.ad || "").toLocaleUpperCase("tr-TR")}`,
            seviye: 0,
            anaBaslikMi: true,
        });

        eklenenler.add(String(ustLokasyon.id));

        const altLokasyonlar = lokasyonAdinaGoreSirala(
            tumListe.filter(
                (lokasyon) =>
                    String(lokasyon.ustBirimId) === String(ustOrgId) &&
                    String(lokasyon.id) !== String(ustLokasyon.id)
            )
        );

        altLokasyonlar.forEach((altLokasyon) => {
            sonuc.push({
                ...altLokasyon,
                gorunenAd: `   - ${altLokasyon.ad}`,
                seviye: 1,
                anaBaslikMi: false,
            });

            eklenenler.add(String(altLokasyon.id));
        });
    });

    const bagimsizLokasyonlar = lokasyonAdinaGoreSirala(
        tumListe.filter((lokasyon) => !eklenenler.has(String(lokasyon.id)))
    );

    bagimsizLokasyonlar.forEach((lokasyon) => {
        sonuc.push({
            ...lokasyon,
            gorunenAd: lokasyon.ad,
            seviye: 0,
            anaBaslikMi: false,
        });
    });

    return sonuc;
};



const getAvatarText = (adSoyad = "") => {
    if (!adSoyad) return "?";

    return adSoyad
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((x) => x[0])
        .join("")
        .toUpperCase();
};

const metinNormalize = (metin = "") => {
    return String(metin)
        .trim()
        .toLocaleLowerCase("tr-TR")
        .replace(/\s+/g, " ");
};

const dakikaText = (dakika, isaretli = false) => {
    if (dakika === null || dakika === undefined || dakika === "") return "";

    const sayi = Number(dakika);

    if (Number.isNaN(sayi)) return "";

    if (sayi === 0) return isaretli ? "0 dk" : "0 dk";

    const negatifMi = sayi < 0;
    const mutlak = Math.abs(sayi);
    const saat = Math.floor(mutlak / 60);
    const dk = mutlak % 60;

    const parcalar = [];

    if (saat > 0) {
        parcalar.push(`${saat} sa`);
    }

    if (dk > 0) {
        parcalar.push(`${dk} dk`);
    }

    const text = parcalar.join(" ");

    if (!isaretli) return text;

    return `${negatifMi ? "-" : "+"}${text}`;
};

const durumLabelGetir = (durum) => {
    const bulunan = fazlaMesaiDurumlari.find((x) => x.value === durum);
    return bulunan?.label || "Seçilmedi";
};

const getPersonelId = (personel = {}) => {
    return String(
        personel.kullaniciId ||
        personel.userId ||
        personel.id ||
        personel.adSoyad ||
        ""
    );
};

const gunIzinMi = (gun = {}) => {
    const durum = metinNormalize(gun.durum);
    const vardiyaAdi = metinNormalize(gun.vardiyaAdi);

    return (
        durum.includes("izin") ||
        durum.includes("haftalık") ||
        durum.includes("haftalik") ||
        vardiyaAdi.includes("izin") ||
        vardiyaAdi.includes("haftalık") ||
        vardiyaAdi.includes("haftalik")
    );
};

const gunCalismaTextGetir = (gun = {}) => {
    return (
        gun.calismaSuresiText ||
        dakikaText(gun.calismaSuresiDakika) ||
        "-"
    );
};

const toplamFazlaEksikTextGetir = (personel = {}) => {
    const fazlaDakika = Number(personel.toplamFazlaMesaiDakika || 0);
    const eksikDakika = Number(personel.toplamEksikSureDakika || 0);

    if (fazlaDakika > 0) {
        return dakikaText(fazlaDakika, true);
    }

    if (eksikDakika > 0) {
        return dakikaText(-eksikDakika, true);
    }

    return "Yok";
};

const gunFarkTextGetir = (gun = {}) => {
    if (gun.fazlaMesaiText) return gun.fazlaMesaiText;

    if (gun.fazlaMesaiDakika) {
        return dakikaText(gun.fazlaMesaiDakika, true);
    }

    if (gun.eksikSureDakika) {
        return dakikaText(-Math.abs(Number(gun.eksikSureDakika)), true);
    }

    return "";
};

function Puantaj() {
    const token = localStorage.getItem("token");
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const authHeader = {
        Authorization: `Bearer ${token}`,
    };

    const [seciliTarih, setSeciliTarih] = useState(inputDateFormat(new Date()));
    const [puantajModu, setPuantajModu] = useState("haftalik");
    const [lokasyonlar, setLokasyonlar] = useState([]);
    const [seciliLokasyonId, setSeciliLokasyonId] = useState("");
    const lokasyonSelectListesi = useMemo(() => {
        return lokasyonSelectListesiOlustur(lokasyonlar);
    }, [lokasyonlar]);
    const [kullaniciAra, setKullaniciAra] = useState("");
    const [pozisyonFiltre, setPozisyonFiltre] = useState("");
    const [yardimAcik, setYardimAcik] = useState(false);

    const [puantajGunleri, setPuantajGunleri] = useState([]);
    const [puantajKayitlari, setPuantajKayitlari] = useState([]);
    const [personelFotoMap, setPersonelFotoMap] = useState({});
    const personelFotoUrlRef = useRef({});

    const [seciliPersoneller, setSeciliPersoneller] = useState([]);
    const [veriYukleniyor, setVeriYukleniyor] = useState(false);
    const [apiHata, setApiHata] = useState("");
    const [mesaj, setMesaj] = useState("");

    const [sayfa, setSayfa] = useState(1);
    const [sayfaBoyutu, setSayfaBoyutu] = useState(10);

    const [detayModal, setDetayModal] = useState({
        acik: false,
        yukleniyor: false,
        data: null,
        hata: "",
    });

    const seciliDate = useMemo(() => {
        return new Date(`${seciliTarih}T00:00:00`);
    }, [seciliTarih]);

    const haftaBaslangic = useMemo(() => {
        return getMonday(seciliDate);
    }, [seciliDate]);

    const ayBaslangic = useMemo(() => {
        return getMonthStart(seciliDate);
    }, [seciliDate]);

    const ayBitis = useMemo(() => {
        return getMonthEnd(seciliDate);
    }, [seciliDate]);

    const tarihAraligiBaslangic = useMemo(() => {
        return puantajModu === "aylik" ? ayBaslangic : haftaBaslangic;
    }, [puantajModu, ayBaslangic, haftaBaslangic]);

    const tarihAraligiBitis = useMemo(() => {
        return puantajModu === "aylik"
            ? ayBitis
            : addDays(haftaBaslangic, 6);
    }, [puantajModu, ayBitis, haftaBaslangic]);

    const ekranTarihleri = useMemo(() => {
        const gunSayisi =
            Math.round(
                (tarihAraligiBitis - tarihAraligiBaslangic) / 86400000
            ) + 1;

        return Array.from({ length: gunSayisi }, (_, index) =>
            addDays(tarihAraligiBaslangic, index)
        );
    }, [tarihAraligiBaslangic, tarihAraligiBitis]);

    const haftaTarihleri = ekranTarihleri;

    const haftaBaslangicApi = useMemo(() => {
        return formatDateForApi(tarihAraligiBaslangic);
    }, [tarihAraligiBaslangic]);

    const haftaBitisApi = useMemo(() => {
        return formatDateForApi(tarihAraligiBitis);
    }, [tarihAraligiBitis]);

    const ekranGunleri = useMemo(() => {
        const apiGunler = apiArrayGetir(puantajGunleri);

        if (apiGunler.length > 0) {
            return apiGunler.map((gun, index) => ({
                tarih: new Date(`${String(gun.tarih).substring(0, 10)}T00:00:00`),
                gunAdi: gun.gunAdi || gunAdlari[index] || "",
            }));
        }

        return ekranTarihleri.map((tarih) => ({
            tarih,
            gunAdi: tarih.toLocaleDateString("tr-TR", {
                weekday: "long",
            }),
        }));
    }, [puantajGunleri, ekranTarihleri]);


    const pozisyonSecenekleri = useMemo(() => {
        const pozisyonlar = apiArrayGetir(puantajKayitlari)
            .map((item) => item.pozisyon || item.pozisyonAdi)
            .filter((pozisyon) => pozisyon && pozisyon !== "-");

        return [...new Set(pozisyonlar)].sort((a, b) =>
            a.localeCompare(b, "tr")
        );
    }, [puantajKayitlari]);

    const filtreliKayitlar = useMemo(() => {
        const kullaniciQ = metinNormalize(kullaniciAra);
        const seciliPozisyon = metinNormalize(pozisyonFiltre);

        return apiArrayGetir(puantajKayitlari).filter((item) => {
            const kullaniciText = metinNormalize(
                [
                    item.adSoyad,
                    item.fullName,
                    item.name,
                    item.pozisyon,
                    item.pozisyonAdi,
                    item.lokasyonAdi,
                ].filter(Boolean).join(" ")
            );

            const pozisyonText = metinNormalize(
                item.pozisyon || item.pozisyonAdi || ""
            );

            const kullaniciMatch =
                !kullaniciQ || kullaniciText.includes(kullaniciQ);

            const pozisyonMatch =
                !seciliPozisyon || pozisyonText === seciliPozisyon;

            return kullaniciMatch && pozisyonMatch;
        });
    }, [puantajKayitlari, kullaniciAra, pozisyonFiltre]);

    const toplamSayfa = useMemo(() => {
        return Math.max(1, Math.ceil(filtreliKayitlar.length / sayfaBoyutu));
    }, [filtreliKayitlar.length, sayfaBoyutu]);

    const sayfadakiKayitlar = useMemo(() => {
        const baslangicIndex = (sayfa - 1) * sayfaBoyutu;
        const bitisIndex = baslangicIndex + sayfaBoyutu;

        return filtreliKayitlar.slice(baslangicIndex, bitisIndex);
    }, [filtreliKayitlar, sayfa, sayfaBoyutu]);

    const listeBaslangic =
        filtreliKayitlar.length === 0
            ? 0
            : (sayfa - 1) * sayfaBoyutu + 1;

    const listeBitis = Math.min(
        sayfa * sayfaBoyutu,
        filtreliKayitlar.length
    );

    const tumSeciliMi =
        sayfadakiKayitlar.length > 0 &&
        sayfadakiKayitlar.every((x) =>
            seciliPersoneller.includes(getPersonelId(x))
        );

    const fotoYetkisiVar = useMemo(() => {
        try {
            const raw = localStorage.getItem("permissionCodes");
            const parsed = raw ? JSON.parse(raw) : [];

            const liste = apiArrayGetir(parsed).map((x) =>
                String(x).trim().toLowerCase()
            );

            return liste.includes("vardiya.birim-personel-fotograflari.goruntule");
        } catch {
            return false;
        }
    }, []);

    const apiUrlTamamla = (url) => {
        if (!url) return "";

        if (/^https?:\/\//i.test(url)) {
            return url;
        }

        return `${apiBaseUrl}${url.startsWith("/") ? "" : "/"}${url}`;
    };

    const personelFotoKeyGetir = (personel = {}) => {
        return String(
            personel.kullaniciId ||
            personel.userId ||
            personel.id ||
            personel.adSoyad ||
            ""
        );
    };

    const personelFotoKaynakGetir = (personel = {}) => {
        const key = personelFotoKeyGetir(personel);

        return (
            personelFotoMap[key] ||
            apiUrlTamamla(
                personel.foto ||
                personel.fotoUrl ||
                personel.profilFotoUrl ||
                personel.profilePhotoUrl ||
                ""
            )
        );
    };

    const mesajGoster = (metin) => {
        setMesaj(metin);

        setTimeout(() => {
            setMesaj("");
        }, 3000);
    };

    const lokasyonlariGetir = async () => {
        try {
            setApiHata("");

            const res = await axios.get(
                `${apiBaseUrl}/api/Vardiya/lokasyonlar?yetki=vardiya.puantaj.goruntule`,
                {
                    headers: authHeader,
                }
            );

            console.log("Puantaj lokasyonları:", res.data);

            const gelenLokasyonlar = apiArrayGetir(res.data);

            setLokasyonlar(gelenLokasyonlar);

            const siraliListe = lokasyonSelectListesiOlustur(gelenLokasyonlar);

            if (siraliListe.length > 0) {
                setSeciliLokasyonId(String(siraliListe[0].id));
            }
        } catch (error) {
            console.error("Puantaj lokasyonları alınamadı:", error);

            setApiHata(
                error.response?.data?.message ||
                "Puantaj lokasyonları alınamadı."
            );
        }
    };

    const puantajGetir = async () => {
        if (!seciliLokasyonId) return;

        try {
            setVeriYukleniyor(true);
            setApiHata("");
            setMesaj("");

            const params = new URLSearchParams();

            params.append("baslangicTarihi", haftaBaslangicApi);
            params.append("bitisTarihi", haftaBitisApi);
            params.append("lokasyonId", seciliLokasyonId);

            if (kullaniciAra.trim()) {
                params.append("ara", kullaniciAra.trim());
            }

            const res = await axios.get(
                `${apiBaseUrl}/api/Vardiya/puantaj?${params.toString()}`,
                {
                    headers: authHeader,
                }
            );

            console.log("Puantaj:", res.data);

            const data = res.data?.data || res.data;

            setPuantajGunleri(apiArrayGetir(data?.gunler));
            setPuantajKayitlari(apiArrayGetir(data?.kayitlar).filter(Boolean));
            setSeciliPersoneller([]);
            setSayfa(1);
        } catch (error) {
            console.error("Puantaj alınamadı:", error);

            setPuantajKayitlari([]);

            setApiHata(
                error.response?.data?.message ||
                "Puantaj verileri alınamadı."
            );
        } finally {
            setVeriYukleniyor(false);
        }
    };

    const fazlaMesaiDurumuGuncelle = async (personel, yeniDurum) => {
        const kullaniciId = getPersonelId(personel);

        if (!kullaniciId || !seciliLokasyonId) return;

        try {
            setVeriYukleniyor(true);
            setApiHata("");

            await axios.put(
                `${apiBaseUrl}/api/Vardiya/puantaj/fazla-mesai-durumu`,
                {
                    kullaniciId,
                    lokasyonId: Number(seciliLokasyonId),
                    baslangicTarihi: haftaBaslangicApi,
                    bitisTarihi: haftaBitisApi,
                    fazlaMesaiDurumu: yeniDurum,
                    aciklama: "Puantaj ekranından güncellendi.",
                },
                {
                    headers: authHeader,
                }
            );

            setPuantajKayitlari((prev) =>
                prev.map((item) => {
                    if (getPersonelId(item) !== kullaniciId) return item;

                    return {
                        ...item,
                        fazlaMesaiDurumu: yeniDurum,
                    };
                })
            );

            mesajGoster("Fazla mesai durumu güncellendi.");
        } catch (error) {
            console.error("Fazla mesai durumu güncellenemedi:", error);

            setApiHata(
                error.response?.data?.message ||
                "Fazla mesai durumu güncellenemedi."
            );
        } finally {
            setVeriYukleniyor(false);
        }
    };

    const detayGetir = async (personel, tarih) => {
        const kullaniciId = getPersonelId(personel);
        const tarihKey = formatDateForApi(tarih);

        if (!kullaniciId || !seciliLokasyonId) return;

        try {
            setDetayModal({
                acik: true,
                yukleniyor: true,
                data: null,
                hata: "",
            });

            const params = new URLSearchParams();

            params.append("kullaniciId", kullaniciId);
            params.append("tarih", tarihKey);
            params.append("lokasyonId", seciliLokasyonId);

            const res = await axios.get(
                `${apiBaseUrl}/api/Vardiya/puantaj/detay?${params.toString()}`,
                {
                    headers: authHeader,
                }
            );

            console.log("Puantaj detay:", res.data);

            setDetayModal({
                acik: true,
                yukleniyor: false,
                data: res.data?.data || res.data,
                hata: "",
            });
        } catch (error) {
            console.error("Puantaj detay alınamadı:", error);

            setDetayModal({
                acik: true,
                yukleniyor: false,
                data: null,
                hata:
                    error.response?.data?.message ||
                    "Puantaj detayı alınamadı.",
            });
        }
    };

    const toggleTumSec = () => {
        const sayfadakiIds = sayfadakiKayitlar.map((x) => getPersonelId(x));

        if (tumSeciliMi) {
            setSeciliPersoneller((prev) =>
                prev.filter((id) => !sayfadakiIds.includes(id))
            );
            return;
        }

        setSeciliPersoneller((prev) => {
            const yeniListe = [...prev];

            sayfadakiIds.forEach((id) => {
                if (!yeniListe.includes(id)) {
                    yeniListe.push(id);
                }
            });

            return yeniListe;
        });
    };

    const togglePersonel = (id) => {
        setSeciliPersoneller((prev) => {
            if (prev.includes(id)) {
                return prev.filter((x) => x !== id);
            }

            return [...prev, id];
        });
    };

    const tarihAraligiDegistir = (yon) => {
        const mevcutTarih = new Date(`${seciliTarih}T00:00:00`);

        if (puantajModu === "aylik") {
            const yeniAy = addMonths(mevcutTarih, yon === "ileri" ? 1 : -1);
            setSeciliTarih(inputDateFormat(getMonthStart(yeniAy)));
        } else {
            const yeniHafta = getMonday(
                addDays(haftaBaslangic, yon === "ileri" ? 7 : -7)
            );

            setSeciliTarih(inputDateFormat(yeniHafta));
        }

        setPuantajGunleri([]);
        setSayfa(1);
    };

    const tarihSecildi = (e) => {
        const secilenTarih = e.target.value;

        if (!secilenTarih) return;

        const tarih = new Date(`${secilenTarih}T00:00:00`);

        if (puantajModu === "aylik") {
            setSeciliTarih(inputDateFormat(getMonthStart(tarih)));
        } else {
            setSeciliTarih(inputDateFormat(getMonday(tarih)));
        }

        setPuantajGunleri([]);
        setSayfa(1);
    };

    const buguneDon = () => {
        const bugun = new Date();

        if (puantajModu === "aylik") {
            setSeciliTarih(inputDateFormat(getMonthStart(bugun)));
        } else {
            setSeciliTarih(inputDateFormat(getMonday(bugun)));
        }

        setPuantajGunleri([]);
        setSayfa(1);
    };

    const filtrele = () => {
        puantajGetir();
    };

    const disariAktar = () => {
        mesajGoster("Excel çıktısını JSON verisinden sonraki adımda hazırlayacağız.");
    };

    const oncekiSayfa = () => {
        setSayfa((prev) => Math.max(1, prev - 1));
    };

    const sonrakiSayfa = () => {
        setSayfa((prev) => Math.min(toplamSayfa, prev + 1));
    };

    const sayfaBoyutuDegistir = (e) => {
        setSayfaBoyutu(Number(e.target.value));
        setSayfa(1);
    };

    const farkClass = (fark) => {
        if (!fark) return "";
        if (String(fark).startsWith("-")) return "eksi";
        if (String(fark).startsWith("+")) return "arti";
        return "";
    };

    const getGunKaydi = (personel, tarih) => {
        const tarihKey = formatDateForApi(tarih);
        const gunKayitlari = apiArrayGetir(personel.gunler);

        return gunKayitlari.find((gun) => {
            const gunTarihKey = String(gun?.tarih || "").substring(0, 10);
            return gunTarihKey === tarihKey;
        });
    };

    const getPuantajOzet = (personel) => {
        const toplamGun =
            personel.toplamGun !== undefined && personel.toplamGun !== null
                ? `${personel.toplamGun} gün`
                : "-";

        const toplamIzin =
            personel.toplamIzinGun !== undefined && personel.toplamIzinGun !== null
                ? `${personel.toplamIzinGun} gün`
                : "-";

        const toplamDevamsizlik =
            personel.toplamDevamsizlikGun !== undefined &&
                personel.toplamDevamsizlikGun !== null
                ? personel.toplamDevamsizlikGun > 0
                    ? `${personel.toplamDevamsizlikGun} gün`
                    : "Devamsızlık yok"
                : "-";

        return {
            fazlaMesaiDurumu: personel.fazlaMesaiDurumu || "Secilmedi",
            toplamGun,
            toplamIzin,
            toplamDevamsizlik,
        };
    };

    useEffect(() => {
        if (!token || puantajKayitlari.length === 0 || !fotoYetkisiVar) return;

        const endpointliPersoneller = apiArrayGetir(puantajKayitlari).filter((personel) => {
            const key = personelFotoKeyGetir(personel);

            return (
                personel.profilFotoEndpoint &&
                !personelFotoUrlRef.current[key]
            );
        });

        if (endpointliPersoneller.length === 0) return;

        let iptalEdildi = false;

        const fotograflariGetir = async () => {
            const yeniFotolar = {};

            await Promise.allSettled(
                endpointliPersoneller.map(async (personel) => {
                    const key = personelFotoKeyGetir(personel);

                    const res = await axios.get(
                        apiUrlTamamla(personel.profilFotoEndpoint),
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                            responseType: "blob",
                        }
                    );

                    const objectUrl = URL.createObjectURL(res.data);

                    personelFotoUrlRef.current[key] = objectUrl;
                    yeniFotolar[key] = objectUrl;
                })
            );

            if (!iptalEdildi && Object.keys(yeniFotolar).length > 0) {
                setPersonelFotoMap((prev) => ({
                    ...prev,
                    ...yeniFotolar,
                }));
            }
        };

        fotograflariGetir();

        return () => {
            iptalEdildi = true;
        };
    }, [puantajKayitlari, token, apiBaseUrl, fotoYetkisiVar]);

    useEffect(() => {
        return () => {
            Object.values(personelFotoUrlRef.current).forEach((url) => {
                URL.revokeObjectURL(url);
            });
        };
    }, []);

    useEffect(() => {
        if (!token) return;

        lokasyonlariGetir();
    }, [token]);

    useEffect(() => {
        if (!seciliLokasyonId) return;

        puantajGetir();
    }, [seciliLokasyonId, haftaBaslangicApi, haftaBitisApi])

    const puantajYardim = [
        {
            heading: "Bu sayfa ne işe yarar?",
            text: "Puantaj ekranı, personellerin vardiya planı ile gerçek giriş-çıkış kayıtlarını karşılaştırmak için kullanılır. Bu ekranda personelin toplam çalışmasını, eksik süresini, fazla mesaisini ve günlük durumlarını takip edebilirsiniz.",
        },
        {
            heading: "İlk olarak ne yapmalısınız?",
            items: [
                "Önce üst bölümden haftalık veya aylık görünümü seçin.",
                "Tarih alanından kontrol etmek istediğiniz hafta veya ayı seçin.",
                "Doğru lokasyonun seçili olduğundan emin olun.",
                "Gerekirse kullanıcı adı veya pozisyon filtresiyle listeyi daraltın.",
            ],
        },
        {
            heading: "Haftalık ve aylık kullanım farkı",
            items: [
                "Haftalık görünüm, seçilen haftadaki personel çalışmalarını gösterir.",
                "Aylık görünüm, seçilen ayın tamamını gösterir.",
                "Aylık görünümde tablo geniş olabilir; sağa-sola kaydırarak tüm günleri görebilirsiniz.",
                "Detaylı kontrol için önce haftalık görünüm kullanılması daha kolaydır.",
            ],
        },
        {
            heading: "Tablodaki bilgiler ne anlama gelir?",
            items: [
                "Toplam Saat, personelin seçili tarih aralığında yaptığı toplam çalışmayı gösterir.",
                "Fazla / Eksik alanı, planlanan vardiyaya göre fazla veya eksik çalışmayı gösterir.",
                "Planlanan süre, personelin vardiya planında çalışması gereken toplam süredir.",
                "Günlük hücrelerde personelin o günkü çalışma, izin, eksik çıkış veya fazla mesai durumu görülebilir.",
            ],
        },
        {
            heading: "Fazla mesai durumu nasıl yorumlanır?",
            items: [
                "Fazla mesai oluşması, personelin planlanan vardiyadan daha fazla çalıştığını gösterir.",
                "Eksik süre oluşması, personelin planlanan vardiyadan daha az çalıştığını gösterir.",
                "Fazla mesai onayı vermeden önce ilgili günlerin giriş-çıkış saatlerini kontrol edin.",
                "Yanlış vardiya planı varsa fazla mesai hesapları da yanlış görünebilir.",
            ],
        },
        {
            heading: "Dikkat edilmesi gerekenler",
            items: [
                "Puantajın doğru hesaplanması için önce vardiya planının doğru girilmiş olması gerekir.",
                "Personelin vardiya planı yoksa sistem çalışılan süreyi fazla mesai gibi gösterebilir.",
                "Eksik çıkış, giriş yok veya çıkış yok gibi durumlarda PDKS kayıtları kontrol edilmelidir.",
                "Lokasyon ve tarih aralığını kontrol etmeden onay işlemi yapmayın.",
            ],
        },
        {
            heading: "En sık yapılan hatalar",
            items: [
                "Yanlış hafta veya ay seçiliyken kontrol yapmak.",
                "Yanlış lokasyon seçiliyken rapora bakmak.",
                "Vardiya planı eksik girildiği halde puantajı hatalı sanmak.",
                "Fazla mesaiyi onaylamadan önce günlük detayları kontrol etmemek.",
                "Aylık tabloda sağa kaydırmadan tüm günleri görmeden karar vermek.",
            ],
        },
        {
            heading: "Kısa öneri",
            text: "Puantaj kontrolünde önce vardiya planının doğru olduğundan emin olun. Sonra fazla/eksik süreleri, giriş-çıkış kayıtlarını ve izinli günleri kontrol ederek işlem yapın.",
        },
    ];;

    return (
        <div className="puantaj-page">
            <section className="shift-filter-card puantaj-filter-card">
                <div className="shift-filter-head puantaj-filter-head">
                    <h2>Yoklama</h2>

                    <div className="puantaj-head-actions">
                        <button
                            type="button"
                            className="sayfa-yardim-btn"
                            onClick={() => setYardimAcik(true)}
                            title="Sayfa yardımı"
                        >
                            ?
                        </button>

                        <div className="puantaj-mode-toggle">
                            <button
                                type="button"
                                className={puantajModu === "haftalik" ? "active" : ""}
                                onClick={() => {
                                    setPuantajModu("haftalik");
                                    setSeciliTarih(
                                        inputDateFormat(
                                            getMonday(new Date(`${seciliTarih}T00:00:00`))
                                        )
                                    );
                                    setPuantajGunleri([]);
                                    setSayfa(1);
                                }}
                            >
                                Haftalık
                            </button>

                            <button
                                type="button"
                                className={puantajModu === "aylik" ? "active" : ""}
                                onClick={() => {
                                    setPuantajModu("aylik");
                                    setSeciliTarih(
                                        inputDateFormat(
                                            getMonthStart(new Date(`${seciliTarih}T00:00:00`))
                                        )
                                    );
                                    setPuantajGunleri([]);
                                    setSayfa(1);
                                }}
                            >
                                Aylık
                            </button>
                        </div>
                    </div>
                </div>

                <div className="shift-filter-grid">
                    <label className="puantaj-date-filter">
                        Tarih
                        <div className="shift-week-control">
                            <button
                                type="button"
                                onClick={() => tarihAraligiDegistir("geri")}
                                title={puantajModu === "aylik" ? "Önceki ay" : "Önceki hafta"}
                            >
                                ‹
                            </button>

                            <div className="shift-week-date-box">
                                <div className="shift-week-date-text">
                                    <span>
                                        {puantajModu === "aylik"
                                            ? formatMonthName(ayBaslangic)
                                            : `${formatDate(tarihAraligiBaslangic)} - ${formatDate(tarihAraligiBitis)}`}
                                    </span>

                                    <small>
                                        {puantajModu === "aylik"
                                            ? `${formatDate(ayBaslangic)} - ${formatDate(ayBitis)}`
                                            : getHaftaBilgisi(haftaBaslangic)}
                                    </small>
                                </div>

                                <input
                                    type="date"
                                    className="shift-date-picker-input"
                                    value={formatDateForApi(tarihAraligiBaslangic)}
                                    onChange={tarihSecildi}
                                    title="Tarih seç"
                                />
                            </div>

                            <button
                                type="button"
                                onClick={() => tarihAraligiDegistir("ileri")}
                                title={puantajModu === "aylik" ? "Sonraki ay" : "Sonraki hafta"}
                            >
                                ›
                            </button>

                            <button
                                type="button"
                                className="shift-this-week-btn"
                                onClick={buguneDon}
                            >
                                {puantajModu === "aylik" ? "Bu Ay" : "Bu Hafta"}
                            </button>
                        </div>
                    </label>

                    <label>
                        Lokasyon
                        <div className="shift-input-like">
                            <select
                                value={seciliLokasyonId}
                                onChange={(e) => setSeciliLokasyonId(e.target.value)}
                            >
                                <option value="">Lokasyon seçiniz</option>
                                {lokasyonSelectListesi.map((lokasyon) => (
                                    <option
                                        key={lokasyon.id}
                                        value={lokasyon.id}
                                        className={
                                            lokasyon.anaBaslikMi
                                                ? "lokasyon-ana-option"
                                                : "lokasyon-alt-option"
                                        }
                                    >
                                        {lokasyon.gorunenAd}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </label>

                    <label>
                        Kullanıcılar
                        <div className="shift-input-like">
                            <input
                                value={kullaniciAra}
                                onChange={(e) => setKullaniciAra(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        puantajGetir();
                                    }
                                }}
                                placeholder="Kullanıcı Ara"
                            />
                        </div>
                    </label>

                    <label>
                        Pozisyon
                        <div className="shift-input-like">
                            <select
                                value={pozisyonFiltre}
                                onChange={(e) => {
                                    setPozisyonFiltre(e.target.value);
                                    setSayfa(1);
                                }}
                            >
                                <option value="">Tüm Pozisyonlar</option>

                                {pozisyonSecenekleri.map((pozisyon) => (
                                    <option key={pozisyon} value={pozisyon}>
                                        {pozisyon}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </label>
                </div>
            </section>

            {apiHata && (
                <div className="puantaj-api-message error">
                    {apiHata}
                </div>
            )}

            {mesaj && (
                <div className="puantaj-api-message success">
                    {mesaj}
                </div>
            )}

            {veriYukleniyor && (
                <div className="puantaj-loading">
                    Puantaj verileri yükleniyor...
                </div>
            )}

            <section className="puantaj-table-card">
                <div className="puantaj-table-box">
                    <table className="puantaj-table">
                        <thead>
                            <tr>
                                <th className="puantaj-check-col">
                                    <input
                                        type="checkbox"
                                        checked={tumSeciliMi}
                                        onChange={toggleTumSec}
                                    />
                                </th>

                                <th className="puantaj-user-col">KULLANICI</th>

                                {ekranGunleri.map((gun, index) => (
                                    <th key={index} className="puantaj-day-col">
                                        <strong>{formatDate(gun.tarih)}</strong>
                                        <span>{gun.gunAdi || gunAdlari[index]}</span>
                                    </th>
                                ))}

                                <th className="puantaj-total-col">TOPLAM SAAT</th>
                                <th className="puantaj-extra-col">FAZLA / EKSİK</th>
                                <th className="puantaj-extra-status-col">FAZLA MESAİ DURUMU</th>
                                <th className="puantaj-day-total-col">TOPLAM GÜN</th>
                                <th className="puantaj-permit-col">TOPLAM İZİN</th>
                                <th className="puantaj-absence-col">TOPLAM DEVAMSIZLIK</th>
                            </tr>
                        </thead>

                        <tbody>
                            {sayfadakiKayitlar.map((personel) => {
                                const personelId = getPersonelId(personel);
                                const adSoyad =
                                    personel.adSoyad ||
                                    personel.fullName ||
                                    personel.name ||
                                    "-";

                                const pozisyon =
                                    personel.pozisyon ||
                                    personel.pozisyonAdi ||
                                    personel.grupAdi ||
                                    "-";

                                const toplamSure =
                                    personel.toplamCalismaText ||
                                    dakikaText(personel.toplamCalismaDakika) ||
                                    "-";

                                const fazlaMesai = toplamFazlaEksikTextGetir(personel);
                                const ozet = getPuantajOzet(personel);

                                return (
                                    <tr
                                        key={personelId}
                                        className={
                                            seciliPersoneller.includes(personelId)
                                                ? "puantaj-selected-row"
                                                : ""
                                        }
                                    >
                                        <td className="puantaj-check-col">
                                            <input
                                                type="checkbox"
                                                checked={seciliPersoneller.includes(personelId)}
                                                onChange={() => togglePersonel(personelId)}
                                            />
                                        </td>

                                        <td className="puantaj-user-col">
                                            <div className="puantaj-user-cell">
                                                {personelFotoKaynakGetir(personel) ? (
                                                    <img
                                                        src={personelFotoKaynakGetir(personel)}
                                                        alt={adSoyad}
                                                    />
                                                ) : (
                                                    <div className="puantaj-avatar">
                                                        {getAvatarText(adSoyad)}
                                                    </div>
                                                )}
                                                <div>
                                                    <strong>{adSoyad}</strong>
                                                    <span>{pozisyon}</span>
                                                </div>
                                            </div>
                                        </td>

                                        {ekranGunleri.map((gun, index) => {
                                            const gunKaydi = getGunKaydi(personel, gun.tarih);
                                            const fark = gunFarkTextGetir(gunKaydi);

                                            return (
                                                <td key={index} className="puantaj-day-cell">
                                                    {gunIzinMi(gunKaydi) ? (
                                                        <button
                                                            type="button"
                                                            className="puantaj-day-detail-btn izin"
                                                            onClick={() => detayGetir(personel, gun.tarih)}
                                                        >
                                                            <div className="puantaj-izin">
                                                                {gunKaydi?.vardiyaAdi || "İzin"}
                                                            </div>
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            className="puantaj-day-detail-btn"
                                                            onClick={() => detayGetir(personel, gun.tarih)}
                                                        >
                                                            <div className="puantaj-sure-wrap">
                                                                {fark && (
                                                                    <strong className={farkClass(fark)}>
                                                                        {fark}
                                                                    </strong>
                                                                )}

                                                                <span>{gunCalismaTextGetir(gunKaydi)}</span>

                                                                {gunKaydi && (
                                                                    <i title="Detay" />
                                                                )}
                                                            </div>
                                                        </button>
                                                    )}
                                                </td>
                                            );
                                        })}

                                        <td className="puantaj-total-col">
                                            <strong>{toplamSure}</strong>
                                        </td>

                                        <td className="puantaj-extra-col">
                                            <strong className={farkClass(fazlaMesai)}>
                                                {fazlaMesai}
                                            </strong>
                                        </td>

                                        <td className="puantaj-extra-status-col">
                                            <select
                                                className={`puantaj-status-select ${ozet.fazlaMesaiDurumu}`}
                                                value={ozet.fazlaMesaiDurumu}
                                                onChange={(e) =>
                                                    fazlaMesaiDurumuGuncelle(personel, e.target.value)
                                                }
                                                disabled={veriYukleniyor}
                                            >
                                                {fazlaMesaiDurumlari.map((durum) => (
                                                    <option key={durum.value} value={durum.value}>
                                                        {durum.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>

                                        <td className="puantaj-day-total-col">
                                            {ozet.toplamGun}
                                        </td>

                                        <td className="puantaj-permit-col">
                                            {ozet.toplamIzin}
                                        </td>

                                        <td className="puantaj-absence-col">
                                            {ozet.toplamDevamsizlik}
                                        </td>
                                    </tr>
                                );
                            })}

                            {sayfadakiKayitlar.length === 0 && (
                                <tr>
                                    <td
                                        colSpan={2 + ekranGunleri.length + 6}
                                        className="puantaj-empty-row"
                                    >
                                        Kayıt bulunamadı.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="puantaj-footer">
                    <span>{seciliPersoneller.length} satır seçildi</span>

                    <div>
                        <span>Sayfa başı:</span>

                        <select
                            className="puantaj-page-size-select"
                            value={sayfaBoyutu}
                            onChange={sayfaBoyutuDegistir}
                        >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                        </select>

                        <span>
                            {listeBaslangic}-{listeBitis} / {filtreliKayitlar.length}
                        </span>

                        <button
                            type="button"
                            onClick={oncekiSayfa}
                            disabled={sayfa <= 1}
                        >
                            ‹
                        </button>

                        <button
                            type="button"
                            onClick={sonrakiSayfa}
                            disabled={sayfa >= toplamSayfa}
                        >
                            ›
                        </button>
                    </div>
                </div>
            </section>

            {detayModal.acik && (
                <div
                    className="puantaj-detail-backdrop"
                    onClick={() =>
                        setDetayModal({
                            acik: false,
                            yukleniyor: false,
                            data: null,
                            hata: "",
                        })
                    }
                >
                    <div
                        className="puantaj-detail-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="puantaj-detail-head">
                            <h3>Puantaj Detayı</h3>

                            <button
                                type="button"
                                onClick={() =>
                                    setDetayModal({
                                        acik: false,
                                        yukleniyor: false,
                                        data: null,
                                        hata: "",
                                    })
                                }
                            >
                                ×
                            </button>
                        </div>

                        {detayModal.yukleniyor && (
                            <div className="puantaj-detail-loading">
                                Detay yükleniyor...
                            </div>
                        )}

                        {detayModal.hata && (
                            <div className="puantaj-api-message error">
                                {detayModal.hata}
                            </div>
                        )}

                        {detayModal.data && (
                            <div className="puantaj-detail-grid">
                                <div>
                                    <span>Personel</span>
                                    <strong>
                                        {detayModal.data.adSoyad ||
                                            detayModal.data.fullName ||
                                            "-"}
                                    </strong>
                                </div>

                                <div>
                                    <span>Tarih</span>
                                    <strong>
                                        {detayModal.data.tarih
                                            ? formatDate(detayModal.data.tarih)
                                            : "-"}
                                    </strong>
                                </div>

                                <div>
                                    <span>Vardiya</span>
                                    <strong>{detayModal.data.vardiyaAdi || "-"}</strong>
                                </div>

                                <div>
                                    <span>Giriş</span>
                                    <strong>{detayModal.data.girisSaati || "-"}</strong>
                                </div>

                                <div>
                                    <span>Çıkış</span>
                                    <strong>{detayModal.data.cikisSaati || "-"}</strong>
                                </div>

                                <div>
                                    <span>Çalışma</span>
                                    <strong>
                                        {detayModal.data.calismaSuresiText ||
                                            dakikaText(detayModal.data.calismaSuresiDakika) ||
                                            "-"}
                                    </strong>
                                </div>

                                <div>
                                    <span>Fazla Mesai</span>
                                    <strong>
                                        {detayModal.data.fazlaMesaiText ||
                                            dakikaText(detayModal.data.fazlaMesaiDakika, true) ||
                                            "-"}
                                    </strong>
                                </div>

                                <div>
                                    <span>Durum</span>
                                    <strong>{detayModal.data.durum || "-"}</strong>
                                </div>

                                {detayModal.data.durumAciklama && (
                                    <div className="wide">
                                        <span>Açıklama</span>
                                        <strong>{detayModal.data.durumAciklama}</strong>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
            <SayfaYardimPopup
                open={yardimAcik}
                onClose={() => setYardimAcik(false)}
                title="Puantaj Ekranı Nasıl Kullanılır?"
                sections={puantajYardim}
            />
        </div>
    );
}

export default Puantaj;